import styled from "styled-components";
import { defaults } from "../../../styles";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

export const Container = styled(defaults.Container)`
  height: ${({ isMovideskContext }) => (isMovideskContext ? 150 : 325)}px;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 0.3;
    width: 100%;
  }

  button:disabled,
  button[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const Input = styled.textarea`
  resize: none;
  border: solid 1px #bebebe;
  border-radius: 3px;
  padding: 10px;
  margin: 10px;
  width: 100%;
  flex: 0.7;
`;

export const ArrowButton = styled.div`
  padding: 5px;
`;

export const SendButton = styled(defaults.Button)`
  align-self: flex-end;
  background-color: #50c86e;
`;

export const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Next = styled(FaArrowRight).attrs({
  className: "next"
})`
  padding-left: 6px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
`;

export const Previous = styled(FaArrowLeft).attrs({
  className: "previous"
})`
  padding-right: 6px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
`;
